// extracted by mini-css-extract-plugin
export var canvas = "_9-1";
export var container = "_9-0";
export var fallback = "_9-2";